import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
import AppBar from "@mui/material/AppBar";
import Divider from "@mui/material/Divider";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";
import ProfilePlaceholder from "../../assets/Images/ProfilePlaceholder.png";
import ChangePasswordMenu from "../ChangePasswordMenu/ChangePasswordMenu";
import Menu from "@mui/material/Menu";
import HomeIcon from "@mui/icons-material/Home";
import { Link, Button } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  appBar: {
    [theme.breakpoints.up("sm")]: {
      width: "100%",
    },
    zIndex: theme.zIndex.drawer + 1,
    color: "black",
    backgroundColor: "white",
  },
  title: {
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "block",
    },
    fontSize: 20,
    fontStyle: "italic",
    color: "#707070",
    fontWeight: 600,
    marginLeft: 10,
    width: 160,
    // whiteSpace: 'pre-wrap',
    lineHeight: "normal",
    fontFamily: "Gill Sans MT",
    marginTop: 5,
  },
  vline: {
    borderLeft: "1px solid #00000029",
    height: 50,
    marginLeft: 50,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
}));

const NavBar = (props) => {
  const { logo, isAuthorize, userName } = props;
  const isSaved = window.localStorage.getItem("isSaved");
  const applicationId = window.localStorage.getItem("applicationId");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openChangePassword, setOpenChangepassword] = React.useState(false);
  const open = Boolean(anchorEl);
  const classes = useStyles();

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const onLogout = () => {
    window.localStorage.removeItem("userData");
    window.localStorage.removeItem("uclToken");
    window.localStorage.removeItem("isSaved");
    window.localStorage.removeItem("isSubmitted");
    window.localStorage.removeItem("isChallanUploaded");
    window.localStorage.removeItem("isTuitionFeeChallanUploaded");
    window.localStorage.removeItem("isDocumentRequested");
    window.localStorage.removeItem("applicationId");
    window.localStorage.removeItem("email");
    window.location.replace("#/login");
  };

  // const handleChangePasswordClick = () => {
  //     setOpenChangepassword(true);
  //     handleClose();

  // }
  const homepage = () => {
    window.location.replace("#/dashboard");
    window.location.reload();
  };

  return (
    <Fragment>
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar
          style={{
            paddingLeft: 3,
            display: "flex",
            justifyContent: "space-between",
            minHeight: `${isAuthorize ? "" : "57px"}`,
          }}
          variant="dense"
        >
          <div style={{ display: "flex" }}>
            <IconButton style={{ padding: 5 }} color="inherit" aria-label="Menu" size="large">
              {logo && <img alt="" src={logo} width={50} />}
            </IconButton>
            <Typography className={classes.title} variant="subtitle1" noWrap>
              {"Universal College Lahore"}
            </Typography>
            <div className={classes.vline}></div>
          </div>
          {isAuthorize && (
            <div>
              {isSaved == 1 && "Application Id: " + applicationId}

              <IconButton
                style={{ marginLeft: 30, color: "#174A84", opacity: "0.8" }}
                onClick={homepage}
                size="large">
                <HomeIcon />
              </IconButton>

              <IconButton
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleMenu}
                color="inherit"
                size="large">
                <img
                  alt=""
                  style={{ borderRadius: "50%" }}
                  src={ProfilePlaceholder}
                  width={30}
                />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={open}
                onClose={handleClose}
              >
                <MenuItem
                  style={{
                    fontWeight: "bold",
                    fontSize: 14,
                    textTransform: "capitalize",
                  }}
                  onClick={handleClose}
                >
                  {userName}
                </MenuItem>
                <Divider />
                {/* <MenuItem style={{ fontSize: 12 }} onClick={handleChangePasswordClick}>Change Password</MenuItem> */}
                <MenuItem onClick={() => onLogout()} style={{ fontSize: 12 }}>
                  Logout
                </MenuItem>
              </Menu>
            </div>
          )}
          {!isAuthorize && (
            <div>
              <Button
                color="primary"
                style={{
                  marginBottom: 10,
                  marginRight: 10,
                  awidth: 150,
                  textTransform: "capitalize",
                  color: "#303F9F",
                  borderColor: "#303F9F",
                }}
                onClick={() => (window.location = "http://ucl.edu.pk/")}
              >
                <Link
                  style={{ textDecoration: "none" }}
                  to="http://ucl.edu.pk/"
                >
                  UCL Home
                </Link>
              </Button>
            </div>
          )}
        </Toolbar>
      </AppBar>
      <ChangePasswordMenu
        open={openChangePassword}
        handleClose={() => setOpenChangepassword(false)}
      />
    </Fragment>
  );
};
NavBar.propTypes = {
  logo: PropTypes.any,
  title: PropTypes.string,
  userName: PropTypes.string,
  isAuthorize: PropTypes.bool,
};

NavBar.defaultProps = {
  logo: null,
  title: "",
  userName: "Student",
  isAuthorize: false,
};

export default NavBar;
